import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { catchError, map, Observable, of, switchMap } from 'rxjs';
import { Router } from '@angular/router';
import { AuthResponse } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private isAuthenticated = false;

  http = inject(HttpClient);
  router = inject(Router);

  login(username: string, password: string): Observable<boolean> {
    return this.http
      .post<any>(
        `${environment.apiBaseUrl}cstm/login`,
        { username, password },
        { withCredentials: true },
      )
      .pipe(
        map((res: AuthResponse) => {
          if (
            res.response?.status === 'success' ||
            res.response?.status === 'alreadyauthenticated'
          ) {
            this.isAuthenticated = true;
            return true;
          }
          return false;
        }),
        catchError((error) => {
          console.error('Login error:', error);
          return of(false);
        }),
      );
  }

  logout(): Observable<boolean> {
    return this.http
      .post<any>(`${environment.apiBaseUrl}cstm/logout`, {
        withCredentials: true,
      })
      .pipe(
        map(() => {
          this.isAuthenticated = false;
          return true;
        }),
        catchError((_) => {
          this.isAuthenticated = false;
          return of(false);
        }),
      );
  }

  checkLoginStatus(): Observable<boolean> {
    return this.http
      .get<any>(`${environment.apiBaseUrl}cstm/userloggedin`, {
        withCredentials: true,
      })
      .pipe(
        map((res: AuthResponse) => {
          if (
            res.response?.status === 'success' ||
            res.response?.status === 'alreadyauthenticated'
          ) {
            this.isAuthenticated = true;
            return true;
          }
          this.isAuthenticated = false;
          return false;
        }),
        catchError(() => {
          this.isAuthenticated = false;
          return of(false);
        }),
      );
  }

  logoutAndResetCsrf(): Observable<boolean> {
    return this.logout().pipe(
      switchMap(() => this.getCsrfCookie()),
      map(() => true),
    );
  }

  getCsrfCookie(): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}csrf-cookie`, {
      withCredentials: true,
    });
  }

  isAuthenticatedUser(): boolean {
    return this.isAuthenticated;
  }
}
